/* global */
export default function() {
  return category => {
    const colors = {
      Technical: 'warning',
      'Accounting Auditing Tax': 'success',
      Tax: 'success',
      'Accounting Auditing': 'warning',
      'Non-Technical': 'success',
      'Personal Development': 'warning',
      'General Ethics': 'info',
      'State Ethics': 'info',
      'General Hours': 'success',
      Fraud: 'primary',
      'Regulatory Review': 'danger'
    };

    return colors[category] || 'default';
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/CategoryColors.js